exports.enrollmentDetailModel = {
  uuid_program_term_detail: null,
  out_of_program: null,
  is_elective: null,
};
